import { Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";

const NodeListInput = ({
  value,
  name,
  setFieldValue,
  error,
  helperText,
  touched,
  ...props
}) => {
  console.log("props", props);
  console.log("error", error);
  console.log("helperText", helperText);
  console.log("touched", touched);

  const onAddPoint = () => {
    const newPoint = { x: "", y: "" };
    setFieldValue(name, [...value, newPoint]);
  };

  const onRemovePoint = (index) => {
    setFieldValue(
      name,
      value.filter((_, i) => i !== index)
    );
  };

  const onChangePoint = (index, field, e) => {
    const newValue = [...value];
    newValue[index] = { ...newValue[index], [field]: e.target.value };
    setFieldValue(name, newValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12} container gap={1} alignItems="center">
        <Typography>مختصات نقطه ها</Typography>

        <Button onClick={onAddPoint} variant="contained" size="small">
          افزودن نقطه
        </Button>
      </Grid>

      {Array.isArray(value)
        ? value.map((item, index) => (
            <Grid item xs={12} md={12} key={index} container spacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="مختصات X"
                  type="number"
                  fullWidth
                  value={item.x}
                  onChange={(e) => onChangePoint(index, "x", e)}
                  error={error?.[index]?.x && touched?.[name]?.[index]?.x}
                  helperText={
                    error?.[index]?.x && touched?.[name]?.[index]?.x
                      ? helperText?.[index]?.x
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="مختصات Y"
                  type="number"
                  fullWidth
                  value={item.y}
                  onChange={(e) => onChangePoint(index, "y", e)}
                  error={error?.[index]?.y && touched?.[name]?.[index]?.y}
                  helperText={
                    error?.[index]?.y && touched?.[name]?.[index]?.y
                      ? helperText?.[index]?.y
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <Button
                  onClick={() => onRemovePoint(index)}
                  variant="outlined"
                  size="small"
                  color="error"
                >
                  حذف نقطه
                </Button>
              </Grid>
            </Grid>
          ))
        : null}
    </Grid>
  );
};

export default NodeListInput;
